"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var closeIcon_svg_1 = __importDefault(require("./closeIcon.svg"));
var getCSSRules = function (fullscreen) { return ({
    close: {
        background: 'none',
        padding: 0,
        border: 'none',
        position: 'absolute',
        top: fullscreen ? 26 : 12,
        right: fullscreen ? 26 : 12,
        zIndex: 10,
        cursor: 'pointer',
        '& img': { verticalAlign: 'top' },
    },
}); };
var ModalCloseButton = function (_a) {
    var onClose = _a.onClose, fullScreen = _a.fullScreen;
    var styles = getCSSRules(fullScreen);
    return ((0, jsx_runtime_1.jsx)("button", __assign({ "aria-label": "Close", onClick: onClose, css: styles.close }, { children: (0, jsx_runtime_1.jsx)("img", { src: closeIcon_svg_1.default, alt: "" }, void 0) }), void 0));
};
exports.default = ModalCloseButton;
//# sourceMappingURL=ModalCloseButton.js.map